// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3vGAG","large":"styles_large__2Dd0l"};